import { observable, action } from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import List from "app/stores/list"

export default class Store {
  @observable apps = []
  @observable keywords = ""
  @observable list

  @action selectAllApp = () => {
    const allAppId = this.apps.map(app => {
      return app.id
    })
    allAppId.shift()
    return allAppId
  }

  @action getApps = () => {
    request.get(`${config.backend}/azf/apps?filter=used`)
      .checkToken()
      .commonDispose()
      .then((res) => {
        this.apps = [{ id: "all", name: "全部" }, ...res]
      })
  }

  @action exportDataStep1 = (groupId, templateId) => {
    return request.post(`${config.backend}/azf/datas/statistic?${this.list.queryString}`)
      .query(this.list.processQueryMap)
      .checkToken()
      .commonDispose()
  }

  static fromJS() {
    const store = new Store()
    store.list = new List(store, "azf/datas/statistic")
    return store
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/azf/statistics.js